// const baseUrl = "http://3.142.246.46:5000";
// const baseUrl = "http://3.128.181.2:5000";3.145.10.120
// const baseUrl = "http://3.145.10.120:3000";
const baseUrl = "http://3.6.91.79:3000";

// const baseUrl = "http://localhost:5000";

export const api = `${baseUrl}/admin/api`;
